import { ISearchPositionResult } from '../../../types/position';
import { phoneNumberAutoFormat2 } from '../../../utils/format-phone';

export class SearchPositionRoleResultModel implements ISearchPositionResult {
  positionId!: ISearchPositionResult['positionId'];
  assignmentType!: ISearchPositionResult['assignmentType'];
  title!: ISearchPositionResult['title'];
  individualId?: ISearchPositionResult['individualId'];
  individualFirstName?: ISearchPositionResult['individualFirstName'];
  individualMiddleName?: ISearchPositionResult['individualMiddleName'];
  individualLastName?: ISearchPositionResult['individualLastName'];
  phoneFaxes?: ISearchPositionResult['phoneFaxes'];
  emails?: ISearchPositionResult['emails'];
  role!: ISearchPositionResult['role'];
  orgId!: ISearchPositionResult['orgId'];
  active!: ISearchPositionResult['active'];

  constructor(src: ISearchPositionResult) {
    Object.assign(this, src);
  }

  get normalizedPositionRole(): string {
    const kind = this.role ? 'Role' : 'Position';
    const assign = (this.assignmentType || '').trim();
    return assign ? `${kind} (${assign})` : kind;
  }

  get normalizedPhoneFaxes(): string {
    if (!this.phoneFaxes || this.phoneFaxes.length === 0) return '';
    return this.phoneFaxes
      .map(p => {
        const countryCode = (p.countryCode || '').trim();
        const areaCode = (p.areaCode || '').trim();
        const localNumber = (p.localNumber || '').replace(/\D/g, '');
        const extension = (p.extension || '').trim();
        return phoneNumberAutoFormat2(countryCode, areaCode, localNumber, extension).trim();
      })
      .filter(s => s.length > 0)
      .sort((a, b) => a.localeCompare(b))
      .join('\n');
  }
}

export default SearchPositionRoleResultModel